export default function setPrintPDFAction(pdfPrintData) {
    return {
        type: 'SET_PDF_PRINT_DATA',
        payload: pdfPrintData
    }
}